<template>
	<div v-if="specialites.length > 0" class="delib-session-summary d-flex flex-wrap align-center gap-1">
		<v-tooltip
			v-for="spec in specialites"
			:key="spec.specialiteId"
			location="bottom"
			max-width="320"
		>
			<template #activator="{ props: tooltipProps }">
				<v-chip
					v-bind="tooltipProps"
					size="x-small"
					variant="outlined"
					class="delib-session-summary-chip"
					@click.stop
				>
					<span class="font-weight-medium">{{ spec.specialiteShort }}</span>
					<span class="text-medium-emphasis mx-1">·</span>
					<span
						v-for="(sem, idx) in spec.semestres"
						:key="sem.semestreId"
						class="delib-session-summary-sem"
					>
						<v-chip
							:color="getSemestreSummaryColor(sem)"
							size="x-small"
							variant="tonal"
							class="delib-session-summary-sem-chip"
						>
							{{ formatSemestreCompact(sem) }}
						</v-chip>
						<span v-if="idx < spec.semestres.length - 1" class="mx-1 text-medium-emphasis">·</span>
					</span>
				</v-chip>
			</template>
			<span class="delib-session-summary-tooltip">{{ formatSpecialiteSummaryTooltip(spec) }}</span>
		</v-tooltip>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Deliberation } from '@/types/deliberation'
import {
	buildDeliberationSessionSummary,
	formatSemestreCompact,
	formatSpecialiteSummaryTooltip,
	getSemestreSummaryColor,
} from '@/utils/deliberationSessionSummary'

const props = defineProps<{
	deliberations: Deliberation[]
}>()

const specialites = computed(() => buildDeliberationSessionSummary(props.deliberations))
</script>

<style scoped>
.delib-session-summary {
	max-width: 100%;
}

.delib-session-summary-chip {
	height: auto !important;
	min-height: 22px;
	padding: 2px 8px !important;
	font-size: 11px;
	line-height: 1.3;
}

.delib-session-summary-sem {
	display: inline-flex;
	align-items: center;
}

.delib-session-summary-sem-chip {
	height: 18px !important;
	font-size: 10px !important;
	padding: 0 5px !important;
}

.delib-session-summary-tooltip {
	white-space: pre-line;
	font-size: 12px;
}
</style>
